export const TIME_DELAY_ANSER = 3000 //ms
export const TIME_MESSAGE_AUTO = 30000 //ms